import { refresh } from 'controller/redux/actions/authActions';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useTokenExpiry = (disable = false) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedin);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (disable) {
            // Skip token expiry checks if disabled
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            return;
        }

        const checkTokenExpiry = () => {
            if (user && user.exp && isLoggedIn) {
                const currentTime = Math.floor(Date.now() / 1000);
                const timeToExpire = user.exp - currentTime;
                if (timeToExpire <= 0) {
                    dispatch(refresh());
                }
            }
        };

        const startInterval = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            intervalRef.current = setInterval(checkTokenExpiry, 60000); // Check every minute
        };

        if (isLoggedIn && user) {
            checkTokenExpiry(); // Immediate check
            startInterval(); // Start periodic checks
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [disable, dispatch, user, isLoggedIn]);
};

export default useTokenExpiry;